<template>
    <div>
        <div class="my-8">
            <BulletPoints />
        </div>

        <v-divider />
        <div class="my-8">
            <TableOfCosts />
        </div>

        <v-divider />
        <div class="my-8">
            <CashFlowSummary />
        </div>

        <v-divider />
        <div class="my-8">
            <AnnualTotals />
        </div>

        <v-divider />
        <div class="my-8">
            <AmortisationSchedule />
        </div>
    </div>
</template>

<script>
import BulletPoints from './BulletPoints.vue';
import TableOfCosts from './TableOfCosts.vue';
import CashFlowSummary from './CashFlowSummary.vue';
import AmortisationSchedule from './AmortisationSchedule.vue';
import AnnualTotals from './AnnualTotals.vue';

export default {
    components: {
        BulletPoints,
        TableOfCosts,
        CashFlowSummary,
        AnnualTotals,
        AmortisationSchedule
    }
};
</script>

<style scoped></style>
